export default __webpack_public_path__ + "static/media/37t.eb9ec918.jpg";